import { render, staticRenderFns } from "./template_type.vue?vue&type=template&id=2ce87884&scoped=true&"
import script from "./template_type.vue?vue&type=script&lang=js&"
export * from "./template_type.vue?vue&type=script&lang=js&"
import style0 from "./template_type.vue?vue&type=style&index=0&id=2ce87884&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce87884",
  null
  
)

export default component.exports